import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { CrudType, ModulesBasedApiSuffix, onActionSubmittedUtil, prepareGetRequestHttpParams, RxjsService } from '@app/shared';
import { CrudService } from '@app/shared/services';
import { MomentService } from '@app/shared/services/moment.service';
import { EventMgntModuleApiSuffixModels } from '@modules/event-management/shared/enums/configurations.enum';
import { DialogService } from 'primeng/api';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';
@Component({
  selector: 'app-signal-info',
  templateUrl: './signal-info.component.html',
  styleUrls: ['./stack-winelands.component.scss'],

})
export class SignalInfoComponent extends PrimeNgTableVariablesModel implements OnInit {
  @Input() occurrenceBookId: string;
  isShowNoRecords: boolean = true;
  @Input() isDefaultLoaderDisabled = false;

  constructor(private crudService: CrudService,
    public dialogService: DialogService,
    private momentService: MomentService,
    private rxjsService: RxjsService) {
    super();
    this.primengTableConfigProperties = {
      selectedTabIndex: 0,
      tableComponentConfigs: {
        tabsList: [
          {
            caption: '',
            dataKey: 'customerId',
            enableScrollable: true,
            cursorLinkIndex: 0,
            cursorSecondLinkIndex: 1,
            columns: [{ field: 'type', header: 'Type', width: '100px' }, { field: 'typeDesc', header: 'Type Desc', width: '100px' }],
            apiSuffixModel: EventMgntModuleApiSuffixModels.OCCURANCE_BOOK_ALARM,
            moduleName: ModulesBasedApiSuffix.EVENT_MANAGEMENT
          },
        ]
      }
    }
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.row['pageIndex'] = 0
    this.row['pageSize'] = 20
    let otherParams = {}
    if (this.occurrenceBookId) {
      this.getRequiredListData(this.row['pageIndex'], this.row['pageSize'], otherParams);
    }
  }

  getRequiredListData(pageIndex?: string, pageSize?: string, otherParams?: object) {
    this.loading = true;
    if (!otherParams && this.isDefaultLoaderDisabled == true) {
      otherParams = {};
      otherParams['isDefaultLoaderDisabled'] = this.isDefaultLoaderDisabled;
    }
    else if (this.isDefaultLoaderDisabled == true && otherParams) {
      otherParams['isDefaultLoaderDisabled'] = this.isDefaultLoaderDisabled;
    }
    let eventMgntModuleApiSuffixModels: EventMgntModuleApiSuffixModels;
    let selectedTabIndex = this.selectedTabIndex ? this.selectedTabIndex : 0
    eventMgntModuleApiSuffixModels = this.primengTableConfigProperties.tableComponentConfigs.tabsList[selectedTabIndex].apiSuffixModel;
    this.crudService.get(
      ModulesBasedApiSuffix.EVENT_MANAGEMENT,
      eventMgntModuleApiSuffixModels,
      this.occurrenceBookId ? this.occurrenceBookId : null,
      false, prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)
    ).subscribe(data => {
      this.loading = false;
      this.rxjsService.setGlobalLoaderProperty(false);
      if (data.isSuccess) {
        this.dataList = data.resources;
        this.isShowNoRecords = false
        this.totalRecords = 0
      } else {
        this.dataList = null;
        this.isShowNoRecords = false;
        this.totalRecords = 0;

      }
    })
  }

  onCRUDRequested(type: CrudType | string, row?: object, unknownVar?: any): void {
    switch (type) {
      case CrudType.GET:
        let otherParams = {};
        if (Object.keys(this.row).length > 0) {
          if (this.row['searchColumns']) {
            Object.keys(this.row['searchColumns']).forEach((key) => {
              if (key.toLowerCase().includes('date')) {
                otherParams[key] = this.momentService.localToUTC(this.row['searchColumns'][key]);
              } else {
                otherParams[key] = this.row['searchColumns'][key];
              }
            });
          }
          if (this.row['sortOrderColumn']) {
            otherParams['sortOrder'] = this.row['sortOrder'];
            otherParams['sortOrderColumn'] = this.row['sortOrderColumn'];
          }
        }
        this.getRequiredListData(row["pageIndex"], row["pageSize"], unknownVar);
    }
  }

  onActionSubmited(e: any) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }
}
